module.exports = __webpack_public_path__ + "static/media/midwestjs-optimized.a83d17ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/midwestjs-optimized.jpg
// module id = 982
// module chunks = 0